import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './common/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-[#FFFC00]" data-id="element-257" data-mp="2ink46bc949k1">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-6" data-id="element-258" data-mp="2nl3gh5pe2c9c">
        <div className="flex justify-between items-center py-4" data-id="element-259" data-mp="2nihavbm266tr">
          {/* Logo */}
          <div className="flex items-center" data-id="element-260" data-mp="2rlvt88xgyzad">
            <div className="flex items-center" data-id="element-261" data-mp="2wkqi9sm15k2x">
              <img src="https://cdn.magicpatterns.com/uploads/qY6eHKoy3QefCFWx8nCVZr/logokr.png" alt="Kraya Logo" className="h-24 w-auto object-contain rounded-3xl" data-id="element-262" data-mp="2wjfi02rsmugk" />
              <span className="text-5xl text-[#1A1A1A] leading-none ml-2 mt-8" style={{
              fontFamily: "'Modak', cursive"
            }} data-id="element-263" data-mp="3ba4vxcwn2no4">
                Kraya
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-3" data-id="element-264" data-mp="2rl8cateegj1p">
            <a href="#how-it-works" className="inline-flex items-center justify-center font-bold rounded-full bg-[#1A1A1A] text-white px-6 py-2.5 text-base hover:bg-gray-800 transition-colors" data-id="element-265" data-mp="2ro492eeih1ok">
              How It Works
            </a>
            <a href="#merchants" className="inline-flex items-center justify-center font-bold rounded-full bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] px-6 py-2.5 text-base hover:bg-gray-50 transition-colors" data-id="element-266" data-mp="3fakhli6lw6yq">
              For Merchants
            </a>
            <a href="#shoppers" className="inline-flex items-center justify-center font-bold rounded-full bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] px-6 py-2.5 text-base hover:bg-gray-50 transition-colors" data-id="element-267" data-mp="30m65shr7p861">
              For Shoppers
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-268" data-mp="1wd5zkimxza80">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-[#1A1A1A] hover:text-gray-600 focus:outline-none p-2" data-id="element-269" data-mp="1wc4qukteeztg">
              {isMenuOpen ? <XIcon className="h-8 w-8" data-id="element-270" data-mp="1ml0cnnbjrizo" /> : <MenuIcon className="h-8 w-8" data-id="element-271" data-mp="18m0mgb8dyw1e" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-272" data-mp="1cmc7hp4nuyde">
        {isMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#FFFC00] border-b-4 border-[#1A1A1A] overflow-hidden" data-id="element-273" data-mp="ypxj521ssrcv">
            <div className="px-4 pt-2 pb-6 space-y-3" data-id="element-274" data-mp="mfprw4snnmig">
              <a href="#how-it-works" className="block py-3 text-center text-[#1A1A1A] font-bold text-xl bg-[#1A1A1A] text-white rounded-full px-6" onClick={() => setIsMenuOpen(false)} data-id="element-275" data-mp="hflc6gzkmvta">
                How It Works
              </a>
              <a href="#merchants" className="block py-3 text-center text-[#1A1A1A] font-bold text-xl bg-white border-2 border-[#1A1A1A] rounded-full px-6" onClick={() => setIsMenuOpen(false)} data-id="element-276" data-mp="rbwsdi2a85t0">
                For Merchants
              </a>
              <a href="#shoppers" className="block py-3 text-center text-[#1A1A1A] font-bold text-xl bg-white border-2 border-[#1A1A1A] rounded-full px-6" onClick={() => setIsMenuOpen(false)} data-id="element-277" data-mp="1a490ymjj43bl">
                For Shoppers
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}